import { render, staticRenderFns } from "./GameLoot.vue?vue&type=template&id=53e1666d&"
import script from "./GameLoot.vue?vue&type=script&lang=js&"
export * from "./GameLoot.vue?vue&type=script&lang=js&"
import style0 from "./GameLoot.vue?vue&type=style&index=0&id=53e1666d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports